import { render, staticRenderFns } from "./CsAutorizacionDetalle.vue?vue&type=template&id=10ed2514"
import script from "./CsAutorizacionDetalle.vue?vue&type=script&lang=js"
export * from "./CsAutorizacionDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports